import { render, staticRenderFns } from "./LicensesAdminView.vue?vue&type=template&id=e10e47fe"
import script from "./LicensesAdminView.vue?vue&type=script&lang=js"
export * from "./LicensesAdminView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports